/**
 * © [2022] Conduent, Inc. All rights reserved. Conduent®and Conduent Agile
 * Star®are trademarks of Conduent, Inc. and/or its subsidiaries in the United
 * States and/or other countries.
 */
import React, { useState } from 'react';
import { useDispatch } from 'react-redux';
import MoveToDetailsIconContainer from '../../NDC/component/MoveToDetailsIconContainer/MoveToDetailsIconContainer';
import { searchNDCByIDORDrugName } from '../../NDC/store/action';
import {
  checkURAAndAddToDetailsTable,
  dispatchErrorMessages,
  removeFromURADetailsTableData,
  setURADetailsTableData,
  setURASearchLoading,
} from '../store/actions';
import URADetailsTable from './URADetailsTable';
import SearchComponent from './SearchComponent';

const SearchByNDC = ({
  fullScreen,
  setFullScreen,
  setErrorMessages,
  validateForm,
  setClickedViewButton,
}) => {
  const dispatch = useDispatch();
  const [searchByNDCID, setSearchByNDCID] = useState('');
  const [error, setError] = useState('');

  const handleSearchClick = async () => {
    const searchByNDCIDSplit = searchByNDCID.split('-');

    if (
      (searchByNDCIDSplit.length == 1 && searchByNDCIDSplit[0].length === 11) ||
      (searchByNDCIDSplit.length === 3 &&
        searchByNDCIDSplit[0].length === 5 &&
        searchByNDCIDSplit[1].length === 4 &&
        searchByNDCIDSplit[2].length === 2)
    ) {
      dispatch(setURASearchLoading(true));
      const searchResult = await searchNDCByIDORDrugName({
        searchBy: 'ndc',
        inputValue: searchByNDCID,
      });
      dispatch(setURASearchLoading(false));

      if (!searchResult) {
        const errorMessage = 'NDC not found';
        dispatch(dispatchErrorMessages([errorMessage]));
        setError(errorMessage);
      } else {
        dispatch(dispatchErrorMessages([]));
        setError(null);
        dispatch(checkURAAndAddToDetailsTable(searchResult));
      }
    } else if (!searchByNDCID || !searchByNDCID.trim()) {
      const errorMessage = 'Please input an NDC to search.';
      dispatch(dispatchErrorMessages([errorMessage]));
      setError(errorMessage);
    } else {
      const errorMessage =
        'Please enter NDC in the format XXXXX-XXXX-XX or XXXXXXXXXXX.';
      dispatch(dispatchErrorMessages([errorMessage]));
      setError(errorMessage);
    }
  };

  return (
    <div className="row">
      <div className="col-5 d-flex">
        <SearchComponent
          searchByNDCID={searchByNDCID}
          setSearchByNDCID={setSearchByNDCID}
          className="ml-0"
          error={error}
          searchOnEnter={handleSearchClick}
        />
      </div>
      <div className="col-2 px-2">
        <MoveToDetailsIconContainer
          handleSingleMove={() => handleSearchClick()}
          handleAllRemove={() => {
            dispatch(setURADetailsTableData([]));
            dispatch(dispatchErrorMessages([]));
          }}
          handleSingleRemove={() => {
            dispatch(removeFromURADetailsTableData());
          }}
        />
      </div>
      <div className="col-5 d-flex flex-column">
        <URADetailsTable
          fullScreen={fullScreen}
          setFullScreen={setFullScreen}
          setError={setError}
          validateForm={validateForm}
          setClickedViewButton={setClickedViewButton}
        />
      </div>
    </div>
  );
};

export default SearchByNDC;
